import React, { PropsWithChildren } from 'react';
import { Skeleton, Text } from '@landr/maestro';
import { noop } from 'utils/noop';
import { css } from '@landr/styled-system/css';

const titleStyles = css({
    display: 'block',
    width: '100%',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
});

const Byline: React.FC<
    PropsWithChildren<{ onClick?: () => void; isLoading?: boolean }>
> = ({ children, isLoading, onClick = noop }) => {
    if (isLoading) {
        return <Skeleton width="60%" height="20px" mb="xl" />;
    }

    return (
        <Text
            textStyle="body-sm"
            color="text.medium"
            onClick={onClick}
            className={titleStyles}
        >
            {children}
        </Text>
    );
};

Byline.displayName = 'Card.Byline';

export default Byline;
